import TemplateInput from '@/components/ui/TemplateInput'
import type { WorkflowNodeData } from '@/types/workflow'

interface SmsMessageConfigProps {
  data: WorkflowNodeData
  updateField: (field: string, value: any) => void
}

import { inputClass, inputStyle, sectionClass, infoBannerClass } from './_kit'
import { Field } from '@/components/ui/Field'
const DEFAULT_CONFIG = {
  message_template: '',
}

export default function SmsMessageConfig({ data, updateField }: SmsMessageConfigProps) {
  const config = (data.sms_message_config || DEFAULT_CONFIG) as {
    message_template: string
  }

  const updateConfig = (updates: Partial<typeof config>) => {
    updateField('sms_message_config', { ...config, ...updates })
  }

  const charCount = config.message_template.length

  return (
    <div className={sectionClass}>
      <Field label="Label">
        {(f) => (
          <input
            {...f}
            type="text"
            className={inputClass} style={inputStyle}
            value={data.label || ''}
            onChange={(e) => updateField('label', e.target.value)}
            placeholder="SMS Message"
          />
        )}
      </Field>

      <Field label="Message Template" as="group">
        <>
          <TemplateInput
            value={config.message_template}
            onChange={(v) => updateConfig({ message_template: v })}
            placeholder="Hi {{contact.first_name}}, following up on... (type {{ for variables)"
            rows={4}
            maxLength={160}
          />
          <div className="flex justify-end mt-1">
            <span
              className={`text-xs ${
                charCount > 160
                  ? 'text-red-500'
                  : charCount > 140
                  ? 'text-yellow-500'
                  : 'text-muted-foreground'
              }`}
            >
              {charCount}/160
            </span>
          </div>
        </>
      </Field>

      <div className={infoBannerClass}>
        <p className="text-xs">
          Requires Twilio credentials configured in Settings. Supports {'{{contact.full_name}}'}, {'{{contact.company_name}}'} placeholders.
        </p>
      </div>
    </div>
  )
}
